import React, { useState } from "react";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import { uploadCsv } from "../../api/physicalInventoryCounts/index.ts";

interface PICUploadCsvModalProps {
  picId: number;
  onSuccess?: () => void;
}

const PICUploadCsvModal: React.FC<PICUploadCsvModalProps> = ({
  picId,
  onSuccess,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const { openSnack } = useSnack();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      openSnack("Por favor seleccione un archivo CSV", "warning");
      return;
    }

    setUploading(true);
    try {
      const response = await uploadCsv(picId, selectedFile);
      openSnack(
        response.data.message || "CSV subido correctamente",
        "success"
      );
      setSelectedFile(null);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      openSnack(handleError(error), "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box sx={{ p: 3, minWidth: 400 }}>
      <Typography variant="h6" gutterBottom>
        Subir Datos CSV
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Seleccione el archivo CSV con los conteos. El formato esperado es:
        Código,Producto,primer conteo,segundo conteo
      </Typography>
      <Box sx={{ mb: 2 }}>
        <input
          accept=".csv"
          style={{ display: "none" }}
          id="csv-upload-input"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="csv-upload-input">
          <Button
            variant="outlined"
            component="span"
            disabled={uploading}
            sx={{ mr: 2 }}
          >
            Seleccionar Archivo
          </Button>
        </label>
        {selectedFile && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            Archivo seleccionado: {selectedFile.name}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFile || uploading}
          startIcon={uploading ? <CircularProgress size={20} /> : null}
        >
          {uploading ? "Subiendo..." : "Subir CSV"}
        </Button>
      </Box>
    </Box>
  );
};

export default PICUploadCsvModal;

